import modules from "@/module";
import { setMenu, getHeader, getDivider } from '@cems-eco/core/src/utils/menu';

const menu = setMenu(modules);


export default [
  getDivider(),
  getHeader("MENU"),
  menu.getMenu("monitor"),
  menu.getMenu("maintenance"),
  menu.getMenu("management"),
  menu.getMenu("report"),
  menu.getMenu("iremote"),
];